/* QuadrantMenuComponent.js */

"use strict";
const _ = require("lodash");
const EventEmitter = require("events");
const Renderer = require("./QuadrantMenuRenderer");

class QuadrantMenuComponent extends EventEmitter {
    constructor(config) {
        super();
        this._state = config.state;
        this._renderer = new Renderer(this);

        this._registerListeners();
    }

    /*******************************************/
    /* START PRIVATE COMPONENT MODEL METHODS */

    /*******************************************/
    _registerListeners() {
        this._state.on("stateChanged", (this._onStateChanged = this._onStateChanged.bind(this)));
    }

    _unregisterListeners() {
        this._state.removeListener("stateChanged", this._onStateChanged);
    }

    _onStateChanged() {
        if (!this._state.disabled) {
            this.renderer.render();
        }
    }

    /*******************************************/
    /* END PRIVATE COMPONENT MODEL METHODS */
    /* START PUBLIC COMPONENT MODEL METHODS */

    /*******************************************/
    get renderer() {
        return this.getRenderer();
    }

    getRenderer() {
        return this._renderer;
    }

    activateDocklet(type) {
        // console.log("activate part "+type);
        this.emit("activatePart", type);
    }

    /**
     * toggles the pinned state of the part list menu
     */
    togglePinned() {
        this._state.togglePinned();
    }

    get pinned() {
        return this._state.pinned;
    }

    set pinned(val) {
        if (_.isBoolean(val)) {
            this._state.pinned = val;
        } else {
            throw new Error("Invalid non boolean value passed for pinned");
        }
    }

    showMenu() {
        this._state.menuVisible = true;
    }

    hideMenu() {
        this._state.menuVisible = false;
    }

    /**
     * Toggles the current state of the part list options
     */

    closeOptions() {
        this._state.optionsOpened = false;
    }

    closeOptionsOnBlur() {
        if (this._state.optionsOpened) {
            this.closeOptions();
        }
    }

    getOptionsOpenedState() {
        return this._state.optionsOpened;
    }

    shutdown() {
        this._unregisterListeners();
        this._state = null;
        this._renderer = null;
        this.emit("Shutdown");
        return Promise.resolve();
    }

    /*******************************************/
    /* END COMPONENT MODEL METHODS */
    /* START PRIVATE METHODS */
    /*******************************************/

    /*******************************************/
    /* END PRIVATE METHODS */
    /* START PUBLIC API METHODS */
    /*******************************************/

    /*******************************************/
    /* END PUBLIC API METHODS */
    /*******************************************/
}

module.exports = QuadrantMenuComponent;
